module.exports = __webpack_public_path__ + "img/game_gchess.6a41971.jpg";